import { Injectable } from '@angular/core';
import { HeaderCfgService } from './headerCfg.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(private headerCfgService: HeaderCfgService) { }

  public getUrl(url: string) {
    return this.headerCfgService.getCfg()[url];
  }

}
